/**
 * Affiche un élément s'il est en `display: none`
 *
 * @param {string} elementSelector Le sélecteur de l'élément à afficher
 *
 * @returns {HTMLElement} L'élément modifié
 */
export const displayIfHidden = (elementSelector) => {
  const element = document.querySelector(elementSelector);

  if (element.style.display === 'none') {
    element.style.removeProperty('display');
  }

  return element;
};
